import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ShowRingsIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M21.8994 2.10059C18.3311 -1.4673 11.186 0.0853953 5.63568 5.6362C0.0853801 11.187 -1.46832 18.3311 2.10008 21.8994C3.39498 23.1943 5.16018 23.8144 7.14938 23.8144C10.6426 23.8144 14.8262 21.9013 18.3633 18.3642C23.9151 12.8129 25.4678 5.66899 21.8994 2.10059ZM16.9492 16.9502C12.3501 21.5479 6.19678 23.167 3.51408 20.4854C0.83098 17.8028 2.45038 11.65 7.04998 7.0503C11.6496 2.4506 17.8027 0.831495 20.4854 3.5146C23.1681 6.19769 21.5488 12.3506 16.9492 16.9502Z"
        fill={color}
      />
      <path
        d="M18.187 5.81297C16.3032 3.92967 12.1099 5.17187 8.6406 8.64107C5.1713 12.1103 3.9292 16.3037 5.8125 18.1875C7.6963 20.0708 11.8896 18.8286 15.3589 15.3594C18.8282 11.8902 20.0703 7.69677 18.187 5.81297ZM14.2983 14.2988C11.2768 17.3193 7.9599 18.2138 6.873 17.1269C5.7861 16.04 6.6806 12.7231 9.7011 9.70157C12.7226 6.68107 16.0395 5.78657 17.1264 6.87347C18.2133 7.96037 17.3188 11.2773 14.2983 14.2988Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ShowRingsIcon.displayName = 'ShowRingsIcon';
